import { EventEmitter } from 'events';
/**
 * 跨组件事件通讯
 */
export default new EventEmitter();
